export default {
  Services: 'Services',
  'Number of applications': 'Number of applications',
  'Number of devices': 'Number of devices',
  'Read more': 'Read more',
  'Website requirements': 'Website requirements',
  'Website URL': 'Payment page URL',
  'I need web integration': 'I need web integration',
  'Select plugin': 'Select plugin',
  'Select method': 'Select method',
  'Fees and charges*': 'Fees and charges*',
  'Additional services*': 'Additional services*',
  Free: 'Free',
  'Payment Schemes*': 'Payment Schemes*',
  '*These fees are subject to 15% VAT.': '*These fees are subject to 15% VAT.',
  'Acceptance of Canada and USA cards require extra approval. Are you selling to Canada or USA? Request a call with sales.':
    'Acceptance of Canada and USA cards require extra approval. Are you selling to Canada or USA? Request a call with sales.',
  'Reset to default': 'Reset to default',
  'Default pricing:': 'Default pricing:',
  'Callback is requested': 'Callback is requested',
  'Special pricing applied': 'Special pricing applied',
  'Total for all applications': 'Total for all applications',
  'Total for all terminals': 'Total for all terminals',
  'General configurations': 'General configurations',
  'Request a callback': 'Request a callback',
  'Please enter you message in the field below. We will contact you as soon as possible.':
    'Please enter you message in the field below. We will contact you as soon as possible.',
  'Your message': 'Your message',
  'Contact me': 'Contact me',
  'Company request': 'Company request',
};
